import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import {
    Component,
    NgZone,
    ViewChild,
    ElementRef,
    Inject,
    Optional,
    OnInit,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ReglaBase } from "app/main/models/regla-base.model";
import { Evaluacion } from "app/main/models/evaluacion.model";
import { first, take } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl } from "@angular/forms";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";
import { environment } from "environments/environment";
import { UtilsService } from "app/main/services/utils.service";
import { FlatTreeControl } from "@angular/cdk/tree";
import {
    MatTreeFlatDataSource,
    MatTreeFlattener,
} from "@angular/material/tree";
import { AppConfig } from "app/app-config";
import { DialogBoxMatchDetailCumplimiento } from "./dialog-match-detail.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "app-dialog-print-box",
    templateUrl: "./dialog-print-box.component.html",
    styleUrls: ["./dialog-print-box.component.scss"],
})
export class DialogBoxPrintCumplimiento {
    action: string;
    displayedColumns: string[] = ["mandato", "submandato", "cumplimiento"];
    displayedColumnsCumplimiento: string[] = [
        "control",
        "evaluacion",
        "resultado",
        "cumplimiento",
    ];

    dataSource: any[] = [];
    reglaBase: ReglaBase = null;
    evaluaciones: Evaluacion[] = [];
    fecha: Date = new Date();
    disabled: boolean = false;
    organizacion: string = "";
    LOCAL_DATA: any;

    constructor(
        public dialog: MatDialog,
        private _ngZone: NgZone,
        public dialogRef: MatDialogRef<DialogBoxPrintCumplimiento>,
        public translate: TranslateService,
        private _snackBar: MatSnackBar,
        private utils: UtilsService,
        private appConfig: AppConfig,
        //private _fuseProgressBarService: FuseProgressBarService,

        // @Optional() is used to prevent error if no data is passed
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        console.log(data);
        //this.controles = data.obj;
        this.action = data.action;
        //this.organizacion = environment.cliente;
        this.organizacion = appConfig.cliente;

        this.LOCAL_DATA = { ...data.obj };
        //this.orderStructure(this.LOCAL_DATA.resultados);
        this.dataSource = this.LOCAL_DATA.resultados;
    }

    closeDialog(): void {
        this.dialogRef.close({ event: "Cancel" });
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 3000,
        });
    }

    public printPdf() {
        this.disabled = true;
        this.utils.printPdf();
        this.disabled = false;
    }

    openDetailsialog(mandato, subMandato, cumplimiento): void {
        var obj = {
            reglaBase: this.LOCAL_DATA.reglaBase,
            mandato: mandato,
            subMandato: subMandato,
            cumplimiento: cumplimiento,
        };
        const dialogRef = this.dialog.open(DialogBoxMatchDetailCumplimiento, {
            width: "100%",
            data: obj,
            disableClose: true,
        });
    }

    orderStructure(resultados): void {
        for (var z = 0; resultados.length > z; z++) {
            resultados[z].nombre = resultados[z].mandato.nombre;
        }
        for (var z = 0; resultados.length > z; z++) {
            resultados.sort(this.utils.sortAlphaNum);
        }
    }
}
